require("./style.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            active: false,
            value: '',
            options: [],
            xOptions: [],
            target: 0
        };
        this.selectIndex = 'select-' + random(10, 999999);
    },
    onInput: function ({size, value, options}) {
        this.state.options = options;
        if (value !== undefined)
            for (let i = 0; i < options.length; i++)
                if (options[i].value == value) {
                    this.state.value = options[i].label || options[i].value;
                    break;
                } else
                    this.state.value = '';
        switch (size) {
        case 'xl':
            this.styles = {
                height: 4.3,
                round: 40
            };
            break;
        case 'lg':
            this.styles = {
                height: 3.5,
                round: 30
            };
            break;
        case 'sm':
            this.styles = {
                height: 3.03,
                round: 15
            };
            break;
        case 'md':
        default:
            this.styles = {
                height: 3.03,
                round: 25
            };
        }
    },
    isActive: function () {
        return this.state.active || $(this.getEl('in-input')).is(':focus');
    },
    onToggle: function (status) {
        this.state.active = status;
        this.state.xOptions = [];
    },
    onKeyword: function (e) {
        if (!e.target.value) {
            this.state.xOptions = [];
            return;
        }
        try {
            this.state.xOptions = this.state.options.filter(({label, value}) => {
                return new RegExp('^' + e.target.value, 'i').test(label || value);
            });
        } catch (error) {
        }
    },
    onKeySelect: function (e) {
        if (!this.state.active || ![
                38,
                40,
                13
            ].includes(e.keyCode))
            return;
        const options = this.state.xOptions.length ? this.state.xOptions : this.state.options;
        switch (e.keyCode) {
        case 13:
            this.onSelect(this.state.target);
            break;
        case 38:
            if (this.state.target > 0)
                this.state.target--;
            break;
        case 40:
            if (this.state.target < options.length)
                this.state.target++;
            break;
        }
    },
    onIngore: function (e) {
        if (!$(e.target).closest('#' + this.selectIndex + '.select-input').length)
            this.state.active = false;
    },
    onSelect: function (index) {
        const option = (this.state.xOptions.length ? this.state.xOptions : this.state.options)[index];
        this.state.value = option.label || option.value;
        this.getEl('in-input').blur();
        this.state.active = false;
        this.emit('select', this.input.returnAll ? option : option.value);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Select/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "position-relative zindex-1 d-flex align-items-center"
      },
    marko_attrs1 = {
        "class": "list-unstyled m-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue("position-relative zindex-" + (state.active ? 3 : 2)),
      style: marko_styleValue(("height:" + component.styles.height) + "rem")
    }, "0", component, null, 1);

  out.be("div", {
      id: component.selectIndex,
      "class": marko_classValue("select-input theme-bg border overflow-hidden " + input.class),
      style: marko_styleValue((((input.class || "").includes("round") ? ("border-radius:" + component.styles.round) + "px;" : "") + " ") + input.style)
    }, "1", component, null, 1);

  out.be("div", marko_attrs0, "2", component);

  _preserve_tag({
      n: true,
      i:  state.active ,
      renderBody: function(out) {
        out.e("input", {
            type: "text",
            "class": marko_classValue(("form-control form-control-" + (input.size || "lg")) + " pl-4 shadow-none border-none"),
            placeholder: input.placeholder || "-- Select Options --",
            value: state.value
          }, "@in-input", component, 0, 0, {
            onfocus: __component.d("focus", "onToggle", false, [
                true
              ]),
            onkeyup: __component.d("keyup", "onKeyword", false)
          });
      }
    }, out, __component, "in-input");

  if (state.options.length) {
    out.e("button", {
        "class": marko_classValue("btn theme-bg btn-icon " + (input.size == "xl" ? " mt-1 mr-1" : "m-0")),
        type: "button"
      }, "3", component, 1, 0, {
        onclick: __component.d("click", "onToggle", false, [
            !state.active
          ])
      })
      .e("i", {
          "class": marko_classValue("bx bx-chevron-down font-large-1 grey-text " + (component.isActive() ? "up" : ""))
        }, "4", component, 0, 1);
  }

  subscribe_tag({
      to: document,
      __events: [
        "on",
        "click"
      ]
    }, out, __component, "5", [
    [
      "click",
      "onIngore",
      false
    ]
  ]);

  subscribe_tag({
      to: document,
      __events: [
        "on",
        "keyup"
      ]
    }, out, __component, "6", [
    [
      "keyup",
      "onKeySelect",
      false
    ]
  ]);

  out.ee();

  if (component.isActive()) {
    AutoScroll_tag({
        class: "options position-relative animated faster slideInDown",
        style: "max-height:" + (input.maxHeight || "220px"),
        renderBody: function(out) {
          out.be("ul", marko_attrs1, "8", component);

          marko_forOf(state.xOptions.length ? state.xOptions : state.options, function({ label, value, divider }, index) {
            if ((label || value) !== state.value) {
              out.e("li", {
                  "class": marko_classValue((((("nav-item " + (divider ? "border-top" : "")) + " ") + (input.fontSize || "font-medium-2")) + " px-2 py-1 ") + (state.target == index ? "theme-bg-fade" : "")),
                  "data-value": value,
                  style: marko_styleValue(input.optionStyle)
                }, "@" + ("opt-" + index), component, 1, 0, {
                  onclick: __component.d("click", "onSelect", false, [
                      index
                    ])
                })
                .t(label || value, component);
            }
          });

          out.ee();
        }
      }, out, __component, "7");
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
